export default __webpack_public_path__ + "static/media/docker-alone.c1458ec6.svg";